import { Inject, Injectable, Optional } from '@angular/core';

@Injectable()
export class AtxLocationService {
    private _location;

    constructor(@Optional() @Inject('WindowLocation') private readonly windowLocation) {
        this._location = windowLocation[0];
    }

    public getPathname() {
        return this._location.pathname;
    }

    public reload() {
        this._location.reload()
    }
}
